import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllGalleryDetails from "../../Components/Admin/AdminAllGalleryDetails";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllGalaryDetailsPage = () => {
  return (
    <AdminAllGalleryDetails />
  );
};

export default AdminAllGalaryDetailsPage;
